import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/curriculum/$curriculumId/')({
  component: lazyRouteComponent(() => import('../-$curriculumId')),
});
